import { aggregateInputs } from './inputs/aggregateInputs';
import { designInputs } from './inputs/designInputs';
import { fieldInputs } from './inputs/fieldInputs';
import { filterInputs } from './inputs/filterInputs';
import { seriesInputs } from './inputs/seriesInputs';


/**
 * Represents the default chart configuration.
 */
export const defaultChart = {
  title: 'My chart',
  type: 'chart',
  graphType: 'columnStacked',
  chartType: 'bar',
  projects: [],
  category: 'metric',
  version: 0,
  visible: true,
  data: [],
  content: {},
  dataset: {},
  width: 700,
  height: 500,
  design: {
    title: {
      text: 'My chart',
      fontSize: 18,
    },
    legend: {
      display: true,
      usePoint: true,
      fontSize: 11,
    },
    xAxis: {
      stacked: true,
    },
    yAxis: {
      stacked: true,
    },
    format: {
      type: 'text',
    },
  },
  query: {
    filters: {},
    aggregation: {},
    limit: 3600,
  },
};

export const defaultBlock = {
  title: 'My text',
  type: 'block',
  visible: true,
  options: {
    block: {
      colors: '__default__',
      title: {
        text: 'My chart',
        fontSize: 18,
      },
      value: {
        fontSize: 50,
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  },
  query: {
    filters: {},
    limit: 3600,
  },
};

// The heatmap and the project map have their settings in their own card: only the title settings here, those of a table.
const titleInputs = designInputs.table.filter((input: any) => input.name === 'title');
// The insight draws its chart like a chart: same visual settings.
export let DESIGN_INPUTS = { ...designInputs, heatmap: titleInputs, projectMap: titleInputs, insight: designInputs.chart };
export let FIELD_INPUTS = fieldInputs;
export const AGGREGATE_INPUTS = aggregateInputs;
export const SERIES_INPUTS = seriesInputs;
export let FILTER_INPUTS = filterInputs;